<template>
  <v-dialog v-model="dialogVisible" 
    persistent
    width="100%"
    max-width="360px" 
  >
    <template #activator="{ on }">
      <v-btn v-on="on">
        Do it Later
      </v-btn>
    </template>

    <v-card>
      <v-card-title>
        <div>
        Are you sure?
        </div>
      </v-card-title>

      <v-card-text>
        If you set up now, your card will be charged 
        <span style="white-space: nowrap;">{{ renewed_on }}</span>, 
        and you wont miss any leads!
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="justify-center py-3">
        <v-btn color="primary" @click="setupNowClick">Set Up Now</v-btn>
        <v-btn @click="laterClick">Later</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapMutations } from 'vuex'

const today = "now"

export default {
  name: 'PaymentLaterDialog',

  props: {
    renewed_on: {
      type: String,
      default: today,
    },
  },

  data() {
    return {
      dialogVisible: false,
    }
  },

  methods: {
    ...mapMutations('alerts', ['SNOOZE']),

    setupNowClick() {
      this.SNOOZE('payment_method')
      window.history.replaceState(null, "", "/home")
      this.$router.push({ name: 'billing/account' })
    },

    laterClick() {
      this.SNOOZE('payment_method')
      this.$router.replace({ name: 'home' })
    },
  }
}
</script>

<style scoped>
  .v-dialog__content {
    position:  absolute;
  }

  .emphasis {
    font-weight: bold;
    color: green;
  }
</style>